import React from "react";
import DynamicEditForm from "../../components/DynamicEditForm/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";

const ProjectManagementEdit = () => {
  // Fetch stored project data
  const projectData = getStoredData()?.[1] || {}; // Ensure projectData is an object

  return (
    <div>
      <h2>Edit {projectData.TitleProject} Management</h2>
      <DynamicEditForm
        fields={projectData.AdminProject} // Pass dynamic fields
        apiUrl={projectData.ApiProject} // Use correct API URL
        successRedirect={projectData.RedirectAdminProject} // Redirect after successful update
      />
    </div>
  );
};

export default ProjectManagementEdit;
